"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Page } from "@widgets/Page";

import { RulesSection } from "@features/rules-section/ui/rules-section";

import { DocumentsSection } from "@entities/document";

import type { MedicalInfoPageType } from "@/_pages/medical-info/model";
import { InfoSection } from "@/_pages/medical-info/ui/info-section";

import s from "./medical-info-page.module.scss";

export type MedicalInfoPageProps = ComponentProps<"div"> & {
  className?: string;
  data: MedicalInfoPageType;
};

export const MedicalInfoPage = (props: MedicalInfoPageProps) => {
  const { className, data } = props;
  const { medicalHelp, rulesSection, documentSection } = data;

  return (
    <Page
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error - Type inference issue between zod schema and TitleWithIconType, but types are compatible at runtime
      title={data.titleWithIcon}
      className={clsx(s.root, className)}
    >
      <InfoSection
        title={medicalHelp?.title}
        description={medicalHelp?.description}
        items={medicalHelp?.phones || []}
      />
      {rulesSection && rulesSection.rules.length > 0 && (
        <RulesSection data={rulesSection} />
      )}
      {documentSection && documentSection.documents.length > 0 && (
        <DocumentsSection data={documentSection} variant="milk" />
      )}
    </Page>
  );
};

MedicalInfoPage.displayName = "MedicalInfoPage";
